'use strict';

/* globals document, $, config, window */

require([config.relative_path + '/plugins/nodebb-plugin-mobile-helpers/static/vendor/panzoom.js'], function (panzoom) {
	$(document).ready(function () {
		createImagePreviewBox();
		addImagePreviewOnMobiles();
	});

	$(window).on('action:ajaxify.end', function () {
		addImagePreviewOnMobiles();
	});

	$(window).on('action:posts.loaded', function () {
		// give some extra time to create DOM elements
		setTimeout(function () { addImagePreviewOnMobiles(); }, 500);
	});

	$(document).on('addImagePreviewOnMobiles', function () {
		addImagePreviewOnMobiles();
	});

	function addImagePreviewOnMobiles() {
		$('a').has('img.img-responsive').click(function (event) {
			event.preventDefault();

			var image = $('#image-mobile-preview img')
				.attr('src', $(this).attr('href'));

			$('#image-mobile-preview')
				.show();

			panzoom(image[0], {
				smoothScroll: true,
				onTouch: function (e) {
					return !($(e.target).hasClass('preview-close') || $(e.target).parent('.preview-close').length);
				},
			});
		});
	}

	function createImagePreviewBox() {
		var previewBox = $('<div id="image-mobile-preview" class="image-mobile-preview"><img alt="" /><button class="preview-close"><i class="fa fa-times" aria-hidden="true"></i></button></div>');

		$('body').append(previewBox);

		$('#image-mobile-preview .preview-close').click(function () {
			previewBox.hide();
		});
	}
});
